<template>
  <div v-show="isApproved || WP.user.id === authorId" :id="'comment-' + id" class="relative my-5 scroll-mt-28">
    <div>
      <div class="relative shadow shadow-zt-shadow bg-zt-normal border -m-[1px] rounded-md"
           :class="showNewBetDiscussionShadow ? 'border-zt-more' : 'border-zt-normal', {'z-backdrop': isBetOptionsModalOpen || isReportModalOpen }">
        <Transition name="fade">
          <bet-options-modal v-if="isBetOptionsModalOpen"
                             :betId="id"
                             :authorId="authorId"
                             :authorName="authorName"
                             :isFollowed="isFollowed"
                             :isBlocked="isUserBlocked"
                             :isWarned="isWarned"
                             :isReported="isReported"
                             :isBetFollowed="isBetFollowed"
                             :warnCount="WarnCount"
                             :isBetDiscussion="true"
                             :betPostId="postId"
                             @close="hideBetOptionsModal"
                             @block="blockUser"
                             @followPost="followPost"
                             @unfollowPost="unfollowPost"
                             @unblock="unblockUser"
                             @warn="warnUser"
                             @removeWarn="removeWarnUser"
                             @removeReport="removeReport"
                             @addReport="addReport"
                             @reportBet="showReportModal"
                             @follow="follow"
                             @unfollow="unfollow"
                             @edit="edit"
                             @deleteBet="deleteBet" />
        </Transition>
        <Transition name="fade">
          <report-modal v-if="isReportModalOpen"
                        :id="id"
                        :type="'betDiscussion'"
                        :link-to-reported-item="`${window.location.origin}/?p=${postId}#comment-${id}/`"
                        @close="hideReportModal" />
        </Transition>
        <div v-if="!isApproved" class="pt-3">
          <p class="font-medium ml-4 text-zt-red text-xs xl:text-sm">W trakcie weryfikacji przez administratorów. Proszę czekać</p>
          <hr class="border-b-2 border-zt-light/30 mx-auto w-full !border-t-0 mt-2.5" />
        </div>
        <div :class="{ 'opacity-60 pointer-events-none': !isApproved }">
          <div class="flex relative items-center rounded-t-md border-b border-zt-light/35 py-3 pl-[14px] pr-4 xl:pl-[14px] xl:pr-[18px] xl:pt-2.5 xl:pb-3">
            <div class="flex items-center group cursor-pointer" @click="window.location.href = '/typer/' + authorId;">
                <div class="relative">
                  <img :src="authorAvatar" alt="" width="50" height="50" @error="handleUserAvatarError($event)"
                      class="!rounded-full mr-2 group-hover:brightness-90 group-active:brightness-75 w-[45px] h-[45px] xl:w-[50px] xl:h-[50px] xl:mr-2.5" />
                  <div v-if="isFollowed"
                      class="absolute right-1 bottom-0 bg-zt-main rounded-full w-5 h-5 flex justify-center items-center xl:right-0"
                      :class="{ 'animate-[show-up_1s_ease-in-out]': followChanged }"
                      data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-delay="500" title="Obserwujesz">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect x="0.5" y="0.5" width="19" height="19" rx="9.5" fill="#3A4B64"/>
                      <rect x="0.5" y="0.5" width="19" height="19" rx="9.5" stroke="white"/>
                      <path d="M10.1293 5.00512C9.23895 5.1766 8.5718 5.78033 8.3181 6.64715C8.26642 6.81629 8.26172 6.87971 8.26172 7.29316C8.26172 7.77943 8.28051 7.92507 8.39092 8.37375C8.64228 9.37448 9.15438 10.1544 9.76046 10.4527C10.0447 10.5913 10.2021 10.6289 10.5051 10.6289C10.9843 10.6289 11.3391 10.4762 11.7055 10.1121C12.2294 9.59529 12.5794 8.81069 12.725 7.82876C12.7791 7.46465 12.7626 6.88676 12.6898 6.63776C12.469 5.86959 11.8841 5.28466 11.1135 5.05915C10.9749 5.01921 10.8645 5.00747 10.5639 5.00277C10.3571 4.99807 10.1622 5.00042 10.1293 5.00512Z" fill="white"/>
                      <path d="M6.88779 6.89214C6.7304 6.94382 6.6012 7.05657 5.77196 7.88346C5.28099 8.37443 4.87225 8.77378 4.8652 8.77378C4.85815 8.77378 4.69841 8.62109 4.51048 8.43551C4.10174 8.03146 4.02187 7.98917 3.70474 8.00327C3.48392 8.01267 3.34532 8.06904 3.20202 8.21234C3.03993 8.37443 3 8.48719 3 8.77378C3 9.00399 3.0047 9.02748 3.06812 9.12615C3.10571 9.18487 3.42284 9.51845 3.77286 9.86847C4.49169 10.5873 4.52693 10.6108 4.82526 10.6249C5.18468 10.6437 5.09306 10.7165 6.49549 9.31643C7.18613 8.62813 7.76401 8.03381 7.79925 7.97508C7.85563 7.87877 7.86267 7.84823 7.86267 7.63446C7.86267 7.36196 7.82039 7.2445 7.66065 7.08476C7.51265 6.93677 7.3811 6.88274 7.14619 6.87804C7.03578 6.87569 6.92068 6.88039 6.88779 6.89214Z" fill="white"/>
                      <path d="M8.58047 10.6807C7.52337 11.0166 6.95723 11.2327 6.71527 11.3854C6.34881 11.6203 6.03403 12.3956 6.00349 13.1308C5.99174 13.3798 5.99644 13.4292 6.04342 13.5466C6.0998 13.6993 6.25014 13.8661 6.40519 13.9483L6.5015 14H10.495H14.4885L14.5942 13.9483C14.6529 13.9178 14.7375 13.8591 14.7821 13.8144C14.8268 13.7698 14.8714 13.7392 14.8785 13.7439C14.8878 13.7486 14.9137 13.7299 14.9372 13.6993C14.9818 13.65 14.9818 13.65 14.9372 13.6829C14.9113 13.7017 14.8972 13.7064 14.9043 13.6946C14.909 13.6805 14.9301 13.6359 14.9466 13.5936C14.9654 13.5537 14.9865 13.5184 14.9936 13.5184C15.0264 13.5184 15.017 13.004 14.9842 12.816C14.9654 12.708 14.9513 12.6117 14.9513 12.6046C14.9536 12.5976 14.9489 12.5741 14.9395 12.5553C14.8761 12.3838 14.8738 12.3603 14.9278 12.2992L14.9818 12.2382L14.9301 12.2828C14.8785 12.3251 14.8761 12.3251 14.862 12.2828C14.6976 11.8177 14.5143 11.524 14.2959 11.3854C14.0563 11.2304 13.3374 10.9555 12.5881 10.7324L12.238 10.629L12.1582 10.6924C11.841 10.9508 11.7353 11.0213 11.5286 11.1223C11.1293 11.3197 10.7933 11.3831 10.3188 11.3525C9.90772 11.3291 9.52951 11.1928 9.156 10.9321C9.06439 10.8686 8.94693 10.7747 8.89525 10.723C8.84592 10.6713 8.78719 10.6314 8.7684 10.6314C8.7496 10.6337 8.66504 10.6549 8.58047 10.6807Z" fill="white"/>
                    </svg>
                  </div>
                  <div v-if="isUserWarned"
                      class="absolute bg-orange-400 w-4 h-4 left-0 top-0 rounded-full no-default-style flex items-center justify-center">
                    <div class="text-sm">{{ WarnCount }}</div>
                  </div>
                  <div v-if="isBlocked"
                      class="opacity-40 absolute top-0 left-0 rounded-full bg-black w-[50px] h-[50px] flex items-center justify-center">
                    <svg class="w-[30px] h-[30px]" viewBox="0 0 214 319" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M197.131 122.59H16.2847C6.8567 122.59 0 130.305 0 138.878V302.617C0 312.048 7.71379 318.906 16.2847 318.906H197.131C206.559 318.906 213.415 311.19 213.415 302.617V138.878C213.415 130.305 205.701 122.59 197.131 122.59ZM128.563 270.898H85.7089C79.7093 270.898 75.4239 264.897 77.9951 258.896L91.7085 229.749C93.4227 226.32 92.5656 222.034 89.1373 219.462C83.1377 214.318 79.7093 207.46 79.7093 198.887C79.7093 178.313 101.994 162.882 124.278 176.598C126.849 178.313 128.563 180.027 129.42 182.599C137.991 197.173 134.563 211.746 125.135 220.319C122.564 222.891 120.85 227.177 122.564 230.606L136.277 259.754C137.991 264.04 134.563 270.898 128.563 270.898Z" fill="white" />
                      <path d="M107.138 0C64.2836 0 30 35.1483 30 77.1547V102.016H62.5694V77.1547C62.5694 52.2938 82.2825 32.5764 107.138 32.5764C131.994 32.5764 151.707 52.2938 151.707 77.1547V102.016H184.276V77.1547C185.133 34.291 149.993 0 107.138 0Z" fill="white" />
                    </svg>
                  </div>
                </div>
              <div class="flex flex-col justify-center grow h-[50px] xl:h-fit">
                <div class="no-default-style block w-fit  text-ellipsis whitespace-nowrap overflow-hidden">
                  <span class="searched-in font-semibold whitespace-normal group-hover:brightness-90 group-active:brightness-75 group-hover:underline text-sm xl:text-base"
                        v-html="authorName"></span>
                </div>
              </div>
            </div>
            <div @click="showBetOptionsModal('comment-' + id)"
                class="basis-8 h-8 shrink-0 rounded-full ml-auto cursor-pointer highlight-none fill-text transition-colors self-center
                  flex justify-center items-center m-0 zt-hover hover:bg-zt-light xl:self-center">
              <svg width="23" height="5" viewBox="0 0 23 5" xmlns="http://www.w3.org/2000/svg">
                <ellipse cx="20.5" cy="2.49031" rx="2.5" ry="2.49031" />
                <ellipse cx="11.5" cy="2.49031" rx="2.5" ry="2.49031" />
                <ellipse cx="2.5" cy="2.49031" rx="2.5" ry="2.49031" />
              </svg>
            </div>
          </div>

          <div v-if="toEdit">
            <TinyMCE :id="'bet-discussion-content-' + data.comment_id"
                    v-model="content"
                    :init="{
                      license_key: 'gpl',
                      height: 250,
                      menubar: false,
                      content_css: false,
                      skin: false,
                      content_style: 'body { font-family:Poppins,Arial,sans-serif; font-size:16px }',
                      plugins: [
                        'autolink', 'lists', 'advlist', 'link', 'charmap', 'preview', 'anchor',
                        'visualblocks', 'code', 'fullscreen', 'table', 'code', 'wordcount'
                      ],
                      toolbar:
                        'undo redo | formatselect | bold italic underline backcolor forecolor | \
                        fontsize | alignleft aligncenter alignright alignjustify | \
                        bullist numlist | code | removeformat '
                    }" />
            <div class="flex justify-end text-xs px-2 py-4 xl:px-6 xl:text-sm">
              <button class="bg-zt-red px-2 py-1 rounded mx-2 zt-hover" @click="cancelEdit">Anuluj</button>
              <button class="bg-green-700 px-2 py-1 rounded zt-hover" @click="saveEdit">Zatwierdź</button>
            </div>
          </div>

          <div v-else-if="!isBlockedBetShown" ref="content"
              class="pl-3.5 pr-[18px] py-3 break-words font-light">
            <span :id="'content-' + data.comment_id"
                  class="discussion-content searched-in text-left text-[14px]" v-html="content"></span>
            <span class="inline-flex items-center w-fit text-zt-more text-sm font-light cursor-default pl-1.5 select-none">
              <span data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-offset="0,10" data-bs-delay="500" :title="absDate"
                    @click="hideTooltip">{{ parsedDate }}</span>
            </span>
            <div v-if="isReported" class="mt-2.5">
              <svg class="inline-block w-4 h-4 mr-[5px] xl:w-5 xl:h-5" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.5013 21.0837C12.76 21.0853 14.0067 20.8382 15.1696 20.3564C16.3325 19.8747 17.3888 19.1679 18.2777 18.2767C19.1689 17.3878 19.8757 16.3316 20.3574 15.1686C20.8391 14.0057 21.0863 12.7591 21.0846 11.5003C21.0862 10.2416 20.8391 8.99495 20.3574 7.83204C19.8757 6.66912 19.1689 5.61286 18.2777 4.72396C17.3888 3.83272 16.3325 3.12594 15.1696 2.64422C14.0067 2.16251 12.76 1.91537 11.5013 1.917C10.2426 1.9154 8.99593 2.16255 7.83301 2.64426C6.6701 3.12597 5.61384 3.83274 4.72493 4.72396C3.83372 5.61286 3.12695 6.66912 2.64524 7.83204C2.16353 8.99495 1.91637 10.2416 1.91798 11.5003C1.91635 12.7591 2.16349 14.0057 2.6452 15.1686C3.12691 16.3316 3.8337 17.3878 4.72493 18.2767C5.61384 19.1679 6.6701 19.8747 7.83301 20.3564C8.99593 20.8381 10.2426 21.0853 11.5013 21.0837Z" stroke="#93A3BA" stroke-width="2" stroke-linejoin="round" />
                <circle cx="11.5" cy="16.6" r="1.1" fill="#93A3BA" />
                <path d="M11.5 5.75V13.4167" stroke="#93A3BA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              <span class="text-xs text-zt-more xl:text-sm">Wpis w trakcie weryfikacji na prośbę użytkowników</span>
            </div>
            <div v-if="isPublishedFromBet" class="mt-2.5">
              <svg class="inline-block w-4 h-4 mr-[5px] xl:w-5 xl:h-5" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.5013 21.0837C12.76 21.0853 14.0067 20.8382 15.1696 20.3564C16.3325 19.8747 17.3888 19.1679 18.2777 18.2767C19.1689 17.3878 19.8757 16.3316 20.3574 15.1686C20.8391 14.0057 21.0863 12.7591 21.0846 11.5003C21.0862 10.2416 20.8391 8.99495 20.3574 7.83204C19.8757 6.66912 19.1689 5.61286 18.2777 4.72396C17.3888 3.83272 16.3325 3.12594 15.1696 2.64422C14.0067 2.16251 12.76 1.91537 11.5013 1.917C10.2426 1.9154 8.99593 2.16255 7.83301 2.64426C6.6701 3.12597 5.61384 3.83274 4.72493 4.72396C3.83372 5.61286 3.12695 6.66912 2.64524 7.83204C2.16353 8.99495 1.91637 10.2416 1.91798 11.5003C1.91635 12.7591 2.16349 14.0057 2.6452 15.1686C3.12691 16.3316 3.8337 17.3878 4.72493 18.2767C5.61384 19.1679 6.6701 19.8747 7.83301 20.3564C8.99593 20.8381 10.2426 21.0853 11.5013 21.0837Z" stroke="#93A3BA" stroke-width="2" stroke-linejoin="round" />
                <circle cx="11.5" cy="16.6" r="1.1" fill="#93A3BA" />
                <path d="M11.5 5.75V13.4167" stroke="#93A3BA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              <span class="text-xs text-zt-more xl:text-sm">Przeniesiono z sekcji Typów do Wpisów Dyskusyjnych</span>
            </div>
          </div>

          <hr class="border-b border-zt-light/35 mx-auto w-full !border-t-0 mt-1" />

          <div v-if="!isBlockedBetShown" class="h-[42px] flex justify-between items-center pl-1.5 pr-3 xl:pl-2.5 xl:pr-4">
            <div class="group flex highlight-none grow">
              <div class="flex items-center gap-0.5 mr-1 text-sm duration-500 transition-colors cursor-pointer zt-hover"
                  :class="isLikedByMe ? 'text-[#419AD4]' : 'text-zt-more'" @click="toggleLike">
                <svg class="w-7 h-7 overflow-hidden rounded-full transition-colors duration-[1s] shrink-0"
                    :class="[{ 'animate-[like-animation_1s]': animate }, isLikedByMe ? 'stroke-transparent fill-[#419AD4]' : 'stroke-zt-more fill-transparent']"
                    viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8.02052 3.29201C7.97899 3.31156 7.953 3.35321 7.95412 3.39843C7.97027 4.05479 7.97835 4.43525 7.97835 4.53979V4.83551L7.92797 4.93901C7.8714 5.05524 7.84218 5.10345 7.42778 5.76467C7.26549 6.02362 7.051 6.37847 6.95113 6.55326C6.8321 6.76157 6.7698 6.99652 6.77024 7.23539L6.77615 10.4265C6.77687 10.8176 7.09988 11.1342 7.49809 11.1342H11.0513L11.1808 11.0718C11.4717 10.9316 11.6853 10.6054 11.6868 10.2988C11.6874 10.1806 11.6836 10.1653 11.6225 10.0417C11.5868 9.96934 11.5594 9.90908 11.5617 9.90775C11.564 9.90642 11.631 9.87712 11.7107 9.84266C12.053 9.69455 12.2544 9.45916 12.269 9.19021C12.2767 9.04821 12.2428 8.95009 12.1285 8.78295C12.0824 8.71557 12.0447 8.65649 12.0447 8.65164C12.0447 8.6468 12.0558 8.64284 12.0695 8.64284C12.0831 8.64284 12.1498 8.61458 12.2177 8.58004C12.5277 8.4223 12.7052 8.12287 12.6549 7.84249C12.6214 7.65568 12.5212 7.50716 12.2986 7.31427L12.2256 7.25107L12.3095 7.16301C12.4176 7.04942 12.4832 6.95595 12.5262 6.85412C12.5546 6.78718 12.5609 6.74432 12.5612 6.6166C12.5617 6.37306 12.5044 6.20983 12.3687 6.06876C12.2778 5.97426 12.1765 5.91277 12.0332 5.86522L11.9155 5.82615C10.2991 5.81738 9.49093 5.81105 9.49096 5.80717C9.49102 5.80134 9.50466 5.6868 9.52127 5.55262C9.55932 5.24537 9.56347 4.6846 9.52919 4.48065C9.43159 3.89988 9.1171 3.44498 8.70331 3.28599C8.5997 3.24619 8.56565 3.2406 8.40398 3.23694C8.30366 3.23467 8.19168 3.2389 8.15517 3.24635C8.11864 3.25379 8.05805 3.27434 8.02052 3.29201ZM4.65918 6.73157H6.03585C6.1572 6.73157 6.25557 6.82819 6.25557 6.94737V11.2209C6.25557 11.3401 6.1572 11.4367 6.03585 11.4367H4.65918C4.53783 11.4367 4.43945 11.3401 4.43945 11.2209V6.94737C4.43945 6.82819 4.53783 6.73157 4.65918 6.73157Z" stroke-width="0.5" />
                </svg>
                <span class="text-xs xl:text-sm">Lubię to!</span>
                <span @animationend="wsLikeAdded = false" class="text-xs mt-[1px] xl:ml-[3px] xl:mr-1">({{ likeCount }})</span>
              </div>
            </div>
            <div @click="toggleAnswer" class="flex flex-nowrap justify-center items-center cursor-pointer highlight-none zt-hover">
              <button data-bs-toggle="collapse" :data-bs-target="'#Comment-input-' + data.comment_id"
                      class="text-zt-more text-xs xl:text-sm">Komentarze ({{ commentWithAnswersCount }})</button>
            </div>
          </div>
          <div v-else class="flex justify-center py-3.5 px-4 xl:px-3">
            <span class="underline text-[14px] text-zt-more zt-hover cursor-pointer" @click="showBlockedBet">
              Rozwiń wpis
            </span>
          </div>
        </div>

        <div :id="'Comment-input-' + data.comment_id" class="collapse" ref="textareaWrapper">
          <div class="w-full h-0.5 bg-zt-light"></div>
          <div v-if="isLoggedIn() && !isUserBlocking" class="flex relative py-2 justify-center items-center gap-x-2 px-1.5 xl:px-2.5">
            <img class="rounded-full w-[30px] h-[30px] min-w-[30px]" height="30" width="30" :src="WP.user.avatar"
                 alt="" @error="handleUserAvatarError($event)"/>
            <div class="font-light py-2 pl-3 !text-text textarea-comments self-stretch overflow-hidden resize-none
                        focus:outline-none !pr-10 block custom-select"
                 @keyup="isMentionEnabled ? handleMentionKeyup($event) : resize()"
                 @keydown="isMentionEnabled && mentionSuggestions.isVisible ? handleMentionKeydown($event) : null"
                 @input="handleInput"
                 ref="textarea"
                 contenteditable="true"></div>
            <UserMentionSuggestions
              v-if="isMentionEnabled && mentionSuggestions.isVisible"
              :bet-id="id"
              is-visible
              :search-query="mentionSuggestions.searchQuery"
              @select-user="handleMentionSelect"
              @close="closeMentionSuggestions"
              ref="mentionSuggestions"
            />
            <div class="absolute top-0 h-full flex items-center right-[18px] xl:right-2">
              <button class="zt-hover xl:h-[calc(100%-20px)] xl:px-4" aria-label="Dodaj komentarz" @click="addComment">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13.7267 7.55476L2.72665 2.05476C2.64044 2.01164 2.5436 1.99437 2.44779 2.00501C2.35198 2.01566 2.2613 2.05377 2.18665 2.11476C2.11536 2.17451 2.06215 2.25295 2.03301 2.34128C2.00386 2.42961 1.99993 2.52432 2.02165 2.61476L3.50165 7.99976L2.00165 13.3698C1.98126 13.4453 1.97888 13.5245 1.9947 13.6012C2.01052 13.6778 2.0441 13.7496 2.09273 13.8109C2.14136 13.8722 2.2037 13.9212 2.27472 13.954C2.34574 13.9868 2.42347 14.0025 2.50165 13.9998C2.57992 13.9993 2.65699 13.9805 2.72665 13.9448L13.7267 8.44476C13.8086 8.4028 13.8773 8.33905 13.9253 8.26054C13.9733 8.18202 13.9987 8.09178 13.9987 7.99976C13.9987 7.90774 13.9733 7.8175 13.9253 7.73898C13.8773 7.66047 13.8086 7.59672 13.7267 7.55476ZM3.27665 12.5548L4.38165 8.49976H9.00165V7.49976H4.38165L3.27665 3.44476L12.3817 7.99976L3.27665 12.5548Z" fill="#93A3BA"/>
                </svg>
              </button>
            </div>
          </div>
          <div v-else-if="isUserBlocking" class="flex justify-center items-center p-2 mt-0.5">
            <span class="text-zt-red text-[12px] zt-hover cursor-pointer truncate" @click="openLoginModal">
              Zostałeś zablokowany przez tego Typera, nie mozesz skomentować jego wpisu
            </span>
          </div>
          <div v-else class="flex justify-center items-center p-2 text-sm">
            <div class="flex justify-center items-center gap-1 zt-hover cursor-pointer" @click="openLoginModal">
              <span class="text-zt-red font-medium">Zaloguj się,</span>
              <span>aby dodać komentarz</span>
            </div>
          </div>
        </div>
      </div>

      <TransitionGroup name="fade">
        <comment v-for="comment in commentsToShow"
                 :key="comment.comment_id"
                 :data="comment"
                 @follow-post="followPost"
                 :isBlocked="betAuthorBlocked(comment.author_id)"
                 :isBlocking="betAuthorBlocking(comment.author_id)"
                 :isBetComment="true"
                 :isBetFollowed="isBetFollowed"
                 :isBetExplicitlyMuted="isBetExplicitlyMuted"
                 :blockedUserIds="blockedUserIds"
                 :bet-id="id"
                 @blockUser="commentAuthorId => $emit('blockUser', commentAuthorId)"
                 @unblockUser="commentAuthorId => $emit('unblockUser', commentAuthorId)" />
      </TransitionGroup>

      <div v-if="!showAllComments && comments.length > 1" class="flex justify-center items-center">
        <button class="bg-zt-main shadow-around px-6 py-2 text-[12px] underline rounded-md mt-2"
                @click="showAllComments = true">
          Pokaż {{ comments.length - 1 }} {{ inflectNumber(comments.length - 1, ['komentarz', 'komentarze', 'komentarzy']) }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Comment from '../Comment.vue';
import { defineAsyncComponent } from 'vue';
import utils_mixin from '../../mixins/utils_mixin';
import { useUserStore } from '../../stores/UserStore';
import { Notice } from '../../../assets/js/Notice';
import { DateTime } from 'luxon';
import TinyMCE from '../TinyMCE.vue';
import UserMentionSuggestions from '../UserMentionSuggestions.vue';
import { useMentions } from '../../composables/useMentions.js';

export default {
  name: 'BetDiscussion',
  emits: ['blockUser', 'unblockUser', 'edit', 'warnUser', 'removeWarnUser', 'editBetIncrement'],
  props: {
    data: Object,
    isBlocked: Boolean,
    isBlocking: Boolean,
    isWarned: Boolean,
    blockedUserIds: Array,
    blockingUserIds: Array,
    warnedUserIds: Array,
    betEdited: Number
  },
  inject: ['WP'],
  mixins: [utils_mixin],
  components: {
    TinyMCE,
    Comment,
    UserMentionSuggestions,
    BetOptionsModal: defineAsyncComponent(() => import('../modals/BetOptionsModal.vue')),
    ReportModal: defineAsyncComponent(() => import('../modals/ReportModal.vue')),
  },
  setup() {
    const userStore = useUserStore();
    const mentions = useMentions();
    return { userStore, mentions };
  },
  data() {
    return {
      isBetOptionsModalOpen: false,
      isReportModalOpen: false,
      comments: [],
      toEdit: false,
      animate: false,
      followChanged: false,
      showNewBetDiscussionShadow: false,
      answerContent: '',
      lastCommentTimestamp: 0,
      isAnswerOpen: false,
      isBlockedBetShown: false,
      wsLikeAdded: false,
      isReported: !!Number(this.data.is_reported_to_verify),
      isPublishedFromBet: !!Number(this.data.is_published_as_discussion),
      showAllComments: false,
      parsedDate: null,
      absDate: null,
      isApproved: true,
	    currentFollowOperation: null,
      isUserWithAdminPanel: this.WP.user.role === 'Admin' || this.WP.user.role === 'Moderator' || this.WP.user.role === 'Redaktor',
      likeCount: this.data.like_count,
      lastAnswerContent: '',
      answerMentions: [],
      mentionSuggestions: {
        isVisible: false,
        searchQuery: '',
        mentionInfo: null,
        isEditMode: false
      }
    };
  },
  mounted() {
    this.comments = this.data.answers ? this.data.answers : [];
    this.isBlockedBetShown = this.betAuthorBlocked(this.authorId);
    this.isApproved = !!Number(this.data.comment_approved);
    this.checkAndRedirectToComment();
    this.checkContentChildrenStyles();
    this.parseDate();
    this.setAbsDate();
    this.ifHasJustBeenAdded();
    this.showBetRedirectBg();
    setTimeout(this.refreshTooltips, 500);

    socket?.on('like-added', data => {
      if (data.postId === Number(this.WP.id)) {
        this.addLikeBySomeoneElse(data);
      }
    });
    socket?.on('like-removed', data => {
      if (data.postId === Number(this.WP.id)) {
        this.removeLikeBySomeoneElse(data);
      }
    });
  },
  watch: {
    isFollowed() {
      this.followChanged = true;
      setTimeout(this.refreshTooltips, 500);
    },
    isUserBlocked() {
      this.isBlockedBetShown = !this.isBlockedBetShown;
    },
    answerContent(newVal) {
      if (!this.$refs.textarea)
        return;
      const newHtml = newVal || '';
      if (newHtml !== this.lastAnswerContent) {
        this.$refs.textarea.innerHTML = newHtml;
        this.lastAnswerContent = newHtml;
      }
    }
  },
  computed: {
	  betFollowers() {
		  return this.data.bet_followers;
	  },
	  isBetExplicitlyMuted() {
		  const followItem = this.betFollowers.filter(item => +item.user_id === this.WP.user.id);
		  if (followItem.length === 1 && followItem[0].muted === '1') {
			  return true;
		  }
		  return false
	  },
	  isBetFollowed() {
		  if (this.currentFollowOperation === 'following') {
			  return true;
		  }
		  if (this.currentFollowOperation === 'muted') {
			  return false;
		  }
		  const followItem = this.betFollowers.filter(item => +item.user_id === this.WP.user.id);
		  if (followItem.length === 1 && followItem[0].muted === '1') {
			  return false;
		  }
		  if (followItem.length === 1 && followItem[0].follows === '1') {
			  return true;
		  }
		  if (this.WP.user.id === +this.authorId) {
			  return true;
		  }
		  const hasUserCommentedBet = this.comments.filter(comment => +comment.author_id === this.WP.user.id).length === 1;
		  let hasNestedUserComment = false;
		  for (let comment of this.comments) {
			  comment.answers?.forEach(ans => {
				  if (+ans.author_id === this.WP.user.id) {
					  hasNestedUserComment = true;
				  }
			  })
		  }
		  if (hasUserCommentedBet || hasNestedUserComment) {
			  return true;
		  }
		  return false;
	  },
    DateTime() {
      return DateTime;
    },
    id() {
      return Number(this.data.comment_id);
    },
    postId() {
      return Number(this.data.post_id);
    },
    authorId() {
      return Number(this.data.author_id);
    },
    authorAvatar() {
      return this.data.author_avatar;
    },
    authorName() {
      return this.data.author_name.replace(/ /, '\n');
    },
    content() {
      return this.betEdited && this.data.content;
    },
    date() {
      return this.data.date;
    },
    isFollowed() {
      return this.userStore.isUserFollowed(this.authorId);
    },
    isUserBlocked() {
      return this.isBlocked;
    },
    isUserBlocking() {
      return this.isBlocking;
    },
    isLikedByMe() {
      if (this.likeCount === 0) return false;

      return this.userStore.isCommentLiked(this.id);
    },
    commentWithAnswersCount() {
      let count = 0;
      if (this.comments.length > 0) {
        this.comments.forEach(child => {
          if ('answers' in child && child.answers.length > 0) {
            count += child.answers.length;
          }
          count++;
        });
      }
      return count;
    },
    commentsToShow() {
      let commentsSorted = this.comments.slice().sort((a, b) => {
        if (a.pinned_to_all !== b.pinned_to_all) {
          return b.pinned_to_all - a.pinned_to_all;
        }

        return new Date(b.date) - new Date(a.date);
      });

      if (this.showAllComments) {
        return commentsSorted;
      } else {
        return commentsSorted.slice(0, 1);
      }
    },
    isUserWarned() {
      return this.isWarned;
    },
    WarnCount() {
      if (this.isWarned && this.warnedUserIds.length > 0) {
        return this.warnedUserIds.find(el => {
          return el.user_id === this.authorId;
        })?.warn_count;
      } else return null;
    },
    isMentionEnabled() {
      return this.WP?.bettingTipsPage || false;
    }
  },
  methods: {
	  followPost() {
      if (!this.isLoggedIn()) {
        this.openLoginModal();
        return;
      }
		  axios
			  .post(this.WP.ajaxUrl, {
				  endpoint: 'api_follow_post_for_notifications',
				  operation: 'follow',
				  comment_id: this.id
			  })
			  .then(response => {
				  this.currentFollowOperation = 'following';
				  const index = this.data.bet_followers.findIndex(item => +item.user_id === this.WP.user.id);
				  if (index !== -1) {
					  this.data.bet_followers[index].muted = '0';
					  this.data.bet_followers[index].follows = '1';
				  } else {
					  this.data.bet_followers.push({
						  user_id: this.WP.user.id,
						  muted: '0',
						  follows: '1'
					  })
				  }
				  this.addInternalNotification(new Notice().setContent(response.data.data.msg + " wpis"));
			  })
	  },
	  unfollowPost() {
      if (!this.isLoggedIn()) {
        this.openLoginModal();
        return;
      }
		  axios
			  .post(this.WP.ajaxUrl, {
				  endpoint: 'api_follow_post_for_notifications',
				  operation: 'mute',
				  comment_id: this.id
			  })
			  .then(response => {
				  this.currentFollowOperation = 'muted';
				  const index = this.data.bet_followers.findIndex(item => +item.user_id === this.WP.user.id);
					if (index !== -1) {
						this.data.bet_followers[index].muted = '1';
						this.data.bet_followers[index].follows = '0';
					} else {
						this.data.bet_followers.push({
							user_id: this.WP.user.id,
							muted: '1',
							follows: '0'
						})
					}
				  this.addInternalNotification(new Notice().setContent(response.data.data.msg + " wpis"));
			  })
	  },
    showBetOptionsModal(elementIdPrefix) {
      if (window.size.desktop && !this.isBlocked) {
        this.smoothScrollToElement(elementIdPrefix);
      }
      this.isBetOptionsModalOpen = true;
      this.blockScrolling();
    },
    hideBetOptionsModal() {
      this.isBetOptionsModalOpen = false;
      this.unblockScrolling();
    },
    parseDate() {
      const currentDate = this.DateTime.now();
      const betDate = this.DateTime.fromSQL(this.date);

      const diff = betDate.diff(currentDate, ['days', 'hours', 'minutes', 'seconds', 'milliseconds']);

      if (diff.days === 0 && diff.hours === 0 && diff.minutes === 0 && diff.seconds >= 0) {
        this.parsedDate = `przed chwilą`;
      } else if (diff.days === 0 && diff.hours === 0 && diff.minutes === 0) {
        this.parsedDate = `przed chwilą`;
      } else if (diff.days === 0 && diff.hours === 0) {
        this.parsedDate = `${-diff.minutes} min. temu`;
      } else if (diff.days === 0) {
        this.parsedDate = `${-diff.hours} godz. temu`;
      } else if (diff.days === -1) {
        this.parsedDate = `1 dzień temu`;
      } else {
        this.parsedDate = `${-diff.days} dni temu`;
      }
      setTimeout(() => {
        this.parseDate();
      }, 60000);
    },
    setAbsDate() {
      const betDate = this.DateTime.fromSQL(this.date);
      let year = '';
      if (betDate.year !== this.DateTime.now().year) {
        year = 'y ';
      }
      this.absDate = betDate.day + betDate.toFormat(` MMMM ${year}'o' HH:mm`);
    },
    hideTooltip(event) {
      for (const element of event.composedPath()) {
        if (typeof element === 'object' && element !== null && 'getAttribute' in element && element.hasAttributes()) {
          for (const attr of element.attributes) {
            if (attr.name === 'data-tooltip-created') {
              setTimeout(() => {
                let tooltip = Tooltip.getInstance(element);
                tooltip.hide();
              }, 3000);
              return;
            }
          }
        }
      }
    },
    showBlockedBet() {
      let index = this.blockedUserIds.findIndex(id => id === this.authorId);
      if (index !== -1) {
        this.isBlockedBetShown = false;
      }
    },
    addLikeBySomeoneElse(data) {
      if (data.commentId === this.id) {
        this.likeCount++;
        this.wsLikeAdded = true;
      }
    },
    removeLikeBySomeoneElse(data) {
      if (data.commentId === this.id) {
        this.likeCount--;
      }
    },
    follow(isCancel = false) {
      if (!this.isLoggedIn()) {
        this.openLoginModal();
        return;
      }
      if (this.blockedUserIds.includes(this.authorId)) {
        return;
      }
      this.userStore.followUser(this.authorId, isCancel);
    },
    unfollow(isCancel = false) {
      if (!this.isLoggedIn()) {
        this.openLoginModal();
        return;
      }
      this.userStore.unfollowUser(this.authorId, isCancel);
    },
    blockUser(isCancel = false) {
      if (!this.isLoggedIn()) {
        this.openLoginModal();
        return;
      }
      axios
        .post(this.WP.ajaxUrl, {
          endpoint: 'api_block_user',
          blocked_user_id: this.authorId
        })
        .then(response => {
          if (response.data.success) {
            this.isBetOptionsModalOpen = false;
            this.$emit('blockUser', this.authorId);
            if (!isCancel) {
              this.addInternalNotification(new Notice().setContent(response.data.data.message)
                  .setCancelAction(this.unblockUser.bind(this, true)));
            }
          } else {
            this.addInternalNotification(new Notice().setContent(response.data.data));
          }
        });
    },
    unblockUser(isCancel = false) {
      if (!this.isLoggedIn()) {
        this.openLoginModal();
        return;
      }
      axios
        .post(this.WP.ajaxUrl, {
          endpoint: 'api_unblock_user',
          blocked_user_id: this.authorId
        })
        .then(response => {
          if (response.data.success) {
            this.$emit('unblockUser', this.authorId);
            if (!isCancel) {
              this.addInternalNotification(new Notice().setContent(response.data.data.message)
                  .setCancelAction(this.blockUser.bind(this, true)));
            }
          } else {
            this.addInternalNotification(new Notice().setContent(response.data.data));
          }
        });
    },
    warnUser() {
      axios
        .post(this.WP.ajaxUrl, {
          endpoint: 'api_warn_user',
          user_id: this.authorId,
          comment_id: this.id,
        })
        .then(response => {
          if (response.data.success) {
            this.$emit('warnUser', this.authorId);
          }
        });
    },
    removeWarnUser() {
      axios
        .post(this.WP.ajaxUrl, {
          endpoint: 'api_remove_warn_user',
          user_id: this.authorId
        })
        .then(response => {
          if (response.data.success) {
            this.$emit('removeWarnUser', this.authorId);
          }
        });
    },
    toggleLike() {
      this.animate = true;
      if (this.isLikedByMe) {
        this.animate = false;
        return this.removeLike();
      } else {
        return this.addLike();
      }
    },
    addLike() {
      axios
        .post(this.WP.ajaxUrl, {
          endpoint: 'api_add_comment_like',
          comment_id: this.id,
	        is_discussion: true,
        })
        .then(response => {
          if (response.data.success) {
            if (response.data.data.message !== 'error') {
              this.userStore.addLikedCommentId(this.id);
              this.likeCount++;
              socket?.emit('like-added', {
                commentId: this.id,
                parentId: this.id,
                postId: this.postId,
                userId: response.data.data.comment_like.user_id,
              });
              if (this.authorId > 0) {
                const notificationData = {
                  recipientId: this.authorId,
                  comment_id: this.id.toString(),
                  post_id: this.postId.toString(),
                  sender_id: response.data.data.comment_like.user_id.toString(),
                  seen: '0',
                  created_at: DateTime.now().toFormat('yyyy-MM-dd HH:mm:ss'),
                  type: 'DiscLike',
                  sender_avatar: this.WP.user.avatar,
                  sender_name: this.WP.user.name || false,
                  id: response.data.data.id
                };
                socket?.emit('notify-user', notificationData);
              }
            }
          }
        });
    },
    removeLike() {
      axios
        .post(this.WP.ajaxUrl, {
          endpoint: 'api_delete_comment_like',
          comment_id: this.id
        })
        .then(response => {
          if (response.data.success) {
            if (response.data.data.message !== 'error') {
              this.userStore.removeLikedCommentId(this.id);
              this.likeCount--;
              socket?.emit('like-removed', {
                commentId: this.id,
                parentId: this.id,
                postId: this.postId,
                userId: this.WP.user.id,
                ip: this.userIP
              });
            }
          }
        });
    },
    ifHasJustBeenAdded() {
      if (this.data.showNewBetDiscussionShadow) {
        this.observeBetShadow();
      }
    },
    checkAndRedirectToComment() {
      const redirectURL = window.location.href;
      const expectedURL = window.location.href.split('#')[0] + '#comment-' + this.id;
      const isRedirecting = redirectURL.includes('#comment-');
      const dashIndex = redirectURL.lastIndexOf('-');

      if (isRedirecting && dashIndex && redirectURL !== expectedURL) { // only for hidden bet comments
        const commentId = redirectURL.substring(dashIndex + 1);
        this.comments.forEach((comment) => {
          if (comment.comment_id === commentId && this.comments.length > 1) {
            this.showAllComments = true;
          } else if (comment.answers.length > 0) {
            comment.answers.forEach((comment2ndLvl) => {
              if (comment2ndLvl.comment_id === commentId) {
                this.showAllComments = true;
              }
            })
          }
        })
      }
    },
    showBetRedirectBg() {
      const currentURL = window.location.href;
      const expectedURL = window.location.href.split('#')[0] + '#comment-' + this.id;
      if (currentURL === expectedURL) {
        this.observeBetShadow()
      }
    },
    observeBetShadow() {
      this.showNewBetDiscussionShadow = true;
      let threshold = this.$el.getBoundingClientRect().height > window.innerHeight - 100
        ? (window.innerHeight - 100) / this.$el.getBoundingClientRect().height
        : 1.0;
      const newBetObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setTimeout(() => (this.showNewBetDiscussionShadow = false), 3000);
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: threshold,
        rootMargin: '0px 0px 0px 0px'
      });
      setTimeout(() => newBetObserver.observe(this.$el), 400);
    },
    checkInputForEmojiCode() {
      this.answerContent = this.answerContent.replace("+++", "✅");
      this.answerContent = this.answerContent.replace("---", "✖");
    },
    resize() {
      const { textarea, textareaWrapper } = this.$refs;
      if (!textarea) return;

      textarea.style.height = 'auto';

      if (textareaWrapper) {
        // Contenteditable mode - resize both wrapper and textarea
        textareaWrapper.style.height = 20 + textarea.scrollHeight + 'px';
        textarea.style.height = 2 + textarea.scrollHeight + 'px';
      } else {
        // Fallback mode
        textarea.style.height = textarea.scrollHeight + 'px';
      }

      this.checkInputForEmojiCode();
    },
    handleInput() {
      const textarea = this.$refs.textarea;
      if (textarea) {
        // Clean broken mentions (modifies DOM in place, preserves cursor)
        this.mentions.cleanBrokenMentions(textarea);
        this.lastAnswerContent = textarea.innerHTML;
        this.answerContent = textarea.innerHTML;
      }

      // Handle mentions if enabled
      if (this.isMentionEnabled) {
        this.handleMentionInput();
      }
    },
    handleMentionInput() {
      const textarea = this.$refs.textarea;
      const cursorPosition = this.mentions.getCaretPosition(textarea);
      const mentionInfo = this.mentions.getMentionTriggerInfo(textarea, cursorPosition);

      if (mentionInfo) {
        this.mentionSuggestions.mentionInfo = mentionInfo;
        this.mentionSuggestions.searchQuery = mentionInfo.searchQuery;
        this.mentionSuggestions.isVisible = true;
      } else {
        this.closeMentionSuggestions();
      }
    },
    handleMentionKeyup(event) {
      this.resize();
      if (event.key === 'Escape') {
        this.closeMentionSuggestions();
      }
    },
    handleMentionKeydown(event) {
      if (!this.mentionSuggestions.isVisible) return;

      const suggestionComponent = this.$refs.mentionSuggestions;

      switch (event.key) {
        case 'ArrowDown':
          event.preventDefault();
          if (suggestionComponent) {
            suggestionComponent.navigateDown();
          }
          break;
        case 'ArrowUp':
          event.preventDefault();
          if (suggestionComponent) {
            suggestionComponent.navigateUp();
          }
          break;
        case 'Enter':
        case 'Tab':
          event.preventDefault();
          if (suggestionComponent) {
            suggestionComponent.selectCurrentUser();
          }
          break;
        case 'Escape':
          event.preventDefault();
          this.closeMentionSuggestions();
          break;
      }
    },
    handleMentionSelect(user) {
      if (!this.mentionSuggestions.mentionInfo) return;

      const textarea = this.$refs.textarea;
      if (textarea) {
        const { newText, id } = this.mentions.insertMention(textarea, this.mentionSuggestions.mentionInfo, user);
        this.answerContent = newText;
        this.answerMentions.push(id);

        // Set cursor position at the end after mention
        this.$nextTick(() => {
          const range = document.createRange();
          const sel = window.getSelection();
          range.selectNodeContents(textarea);
          range.collapse(false); // Collapse to end
          sel.removeAllRanges();
          sel.addRange(range);
          textarea.focus();
        });
      }

      this.closeMentionSuggestions();
    },
    closeMentionSuggestions() {
      this.mentionSuggestions.isVisible = false;
      this.mentionSuggestions.searchQuery = '';
      this.mentionSuggestions.mentionInfo = null;
    },
    toggleAnswer() {
      this.isAnswerOpen = !this.isAnswerOpen;

      if (this.isAnswerOpen) {
        setTimeout(() => {
          const { textarea } = this.$refs;
          if (textarea) {
            textarea.focus();
          }
        }, 200);
      }
    },
    addComment() {
      if (this.lastCommentTimestamp && this.DateTime.now().toSeconds() - this.lastCommentTimestamp < 10) {
        this.addInternalNotification(new Notice().setContent('Odczekaj chwilę, zanim dodasz kolejny komentarz'));
        return;
      }

      let commentContent = this.answerContent.replaceAll("✅", "<span style='font-size: 18px;'>✅</span>");
      commentContent = commentContent.replaceAll("✖", "<span style='font-size: 18px;'>✖</span>");

      if (commentContent.replace(/\s/g, "").length < 1) {
        this.addInternalNotification(new Notice().setContent('Dodaj treść komentarza'));
        return;
      }

      this.lastCommentTimestamp = this.DateTime.now().toSeconds();

      axios
        .post(this.WP.slowAjaxUrl, {
          endpoint: 'api_add_comment',
          post_id: this.postId,
          parent_id: this.id,
          parent_type: {
            parent: 'Discussion',
            grandparent: 'TD'
          },
          content: commentContent.trim(),
          comment_type: 'comment',
          year: this.DateTime.fromSQL(this.WP.dailyBetsDate).year,
          month: this.DateTime.fromSQL(this.WP.dailyBetsDate).month,
          mentions: this.answerMentions,
        })
        .then(response => {
          if (response.data.success) {
            if (!this.isBetFollowed) {
              this.followPost();
            }
            this.comments.unshift(response.data.data.comment);
            this.isAnswerOpen = false;
            this.answerContent = '';
            this.answerMentions = [];
            this.lastAnswerContent = '';
            setTimeout(() => this.resize(), 200);
          } else {
            this.addInternalNotification(new Notice().setContent(response.data.data));
          }
        });
    },
    addReport() {
      axios
        .post(this.WP.ajaxUrl, {
          endpoint: 'api_set_bet_verification_warning',
          bet_id: this.id,
          status: true
        })
        .then(response => {
          if (response.data.success) {
            this.isReported = true;
          } else {
            this.addNotification(new Notice().setContent('Coś poszło nie tak spróbuj ponownie'));
          }
        });
    },
    removeReport() {
      axios
        .post(this.WP.ajaxUrl, {
          endpoint: 'api_set_bet_verification_warning',
          bet_id: this.id,
          status: false
        })
        .then(response => {
          if (response.data.success) {
            this.isReported = false;
          } else {
            this.addNotification(new Notice().setContent('Coś poszło nie tak spróbuj ponownie'));
          }
        });
    },
    showReportModal() {
      this.isReportModalOpen = true;
      setTimeout(() => {
        this.blockScrolling();
      }, 50);
    },
    hideReportModal() {
      this.isReportModalOpen = false;
      this.unblockScrolling();
    },
    betAuthorBlocked(authorId) {
      return this.blockedUserIds.includes(Number(authorId));
    },
    betAuthorBlocking(authorId) {
      return this.blockingUserIds.includes(Number(authorId));
    },
    betAuthorWarned(authorId) {
      return this.warnedUserIds.some(el => {
        return el.user_id === Number(authorId);
      });
    },
    edit() {
      this.toEdit = true;
    },
    cancelEdit() {
      this.toEdit = false;
    },
    saveEdit() {
      let content = tinymce.get('bet-discussion-content-' + this.data.comment_id).getContent();

      content = content.replace(/[\n\r]+/g, ""); // Usuwa nowe linie
      content = content.replace(/ +(?= )/g, ""); // Usuwa podwójne spacje

      axios
        .post(this.WP.ajaxUrl, {
          endpoint: 'api_update_bet_discussion_or_ad',
          content: content,
          id: this.data.comment_id
        })
        .then(response => {
          if (response.data.success) {
            this.data.content = content;
            this.toEdit = false;
            this.$emit('editBetIncrement');
            this.checkContentChildrenStyles();
          }
        });
    },
    deleteBet() {
      axios
        .post(this.WP.slowAjaxUrl, {
          endpoint: 'api_delete_comment',
          id: this.id
        })
        .then(response => {
          if (response.data.success) {
            this.addInternalNotification(new Notice().setContent(response.data.data.message + '. Odśwież stronę'));
          } else {
            this.addNotification(new Notice().setContent('Coś poszło nie tak spróbuj ponownie'));
          }
        });
    },
    checkContentChildrenStyles() {
      const contentElement = this.$refs.content;
      if (contentElement) {
        const spanElements = contentElement.querySelectorAll('span[style]');
      
        if (spanElements.length > 0) {
          contentElement.classList.remove('content-leading');
        } else {
          contentElement.classList.add('content-leading');
        }
      }
    }
  }
};
</script>

<style scoped>
.searched-in .searched-element {
  background-color: #6FAD6E99;
}

.content-leading {
  line-height: 21px;
}
</style>